export const paket = [
    {
        id : 'P001',
        name : 'Sumatran Jungle Eco-tourism Discovery: Orangutans, Elephants, and Cultural Fusion (3D/2N)',
        pax : 3,
        duration : 3, 
        price : 'Rp. 500.000',
        detail : [
            {
                day : 1,
                program : 'Program Medan',
                destination : 'Medan',
                activity : 'Tjong Afie'
            },
            {
                day : 2,
                program : 'BKL',
                destination : 'Bukit Lawang',
                activity : 'Elephant Wash'
            }
        ]
    },
    {
        id : 'P002',
        name : 'Paket 2 (3D/2N)',
        pax : 3,
        duration : 3, 
        price : 'Rp. 500.000',
        detail : [
            {
                day : 1,
                program : 'Program d-1',
                destination : 'destination d-1',
                activity : 'activity d-1'
            },
            {
                day : 2,
                program : 'Program d-2',
                destination : 'destination d-2',
                activity : 'activity d-2'
            }
        ]
    },
    {
        id : 'P003',
        name : 'Paket 3 (3D/2N)',
        pax : 3,
        duration : 3, 
        price : 'Rp. 500.000',
        detail : [
            {
                day : 1,
                program : 'Program d-1',
                destination : 'destination d-1',
                activity : 'activity d-1'
            },
            {
                day : 2,
                program : 'Program d-2',
                destination : 'destination d-2',
                activity : 'activity d-2'
            }
        ]
    },
    {
        id : 'P004',
        name : 'Paket 4 (3D/2N)',
        pax : 3,
        duration : 3, 
        price : 'Rp. 500.000',
        detail : [
            {
                day : 1,
                program : 'Program d-1',
                destination : 'destination d-1',
                activity : 'activity d-1'
            },
            {
                day : 2,
                program : 'Program d-2',
                destination : 'destination d-2',
                activity : 'activity d-2'
            }
        ]
    },
    {
        id : 'P005',
        name : 'Paket 5 (3D/2N)',
        pax : 3,
        duration : 3, 
        price : 'Rp. 500.000',
        detail : [
            {
                day : 1,
                program : 'Program d-1',
                destination : 'destination d-1',
                activity : 'activity d-1'
            },
            {
                day : 2,
                program : 'Program d-2',
                destination : 'destination d-2',
                activity : 'activity d-2'
            }
        ]
    }
]

